import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import FlexPanel from '../FlexPanel';
import ApiService from '../../services/ApiService';
import { handleCancel, handleDocuments, handleHistory, handleReassign, handleApprove } from './actions';
import OnlineStatus from '../chat/OnlineStatus';
import browserHistory from '../../history';
import { getCustomerName } from './util';
import SimpleQuoteLink from './SimpleQuoteLink';

const ManagerQuoteList = ({ toolbar }) => {
  const { users } = useSelector(state => state.chat);
  const { isLoading, data = [] } = useQuery('my-quotes', async () => {
    const { data } = await ApiService.get('crm/quotes/open-detailed');
    return data;
  });

  return (
    <FlexPanel header="Recent Quotes" toolbar={toolbar}>
      <div className="quote-list">
        {isLoading === true ? (
          <div />
        ) : (
          <table>
            <tbody>
              {data.map(quote => {
                const customer = getCustomerName(quote.Customer);
                const vehicle = `[${quote.vehicleId}] ${quote.Vehicle.Year} ${quote.Vehicle.Make || ''} ${
                  quote.Vehicle.Model || ''
                }`;
                return (
                  <tr key={quote.id}>
                    <td width="10">
                      <i
                        className="fas fa-circle"
                        style={{ color: quote.QuoteState.color }}
                        title={quote.QuoteState.name}
                      />
                    </td>
                    <td>
                      <SimpleQuoteLink quote={quote} />
                    </td>
                    <td>
                      <DropdownButton
                        id="actions"
                        className="quote-dropdown"
                        title={<div className="quote-dropdown-label">{customer}</div>}
                        variant="link"
                        alignRight
                        size="xs"
                      >
                        <Dropdown.Item onClick={() => browserHistory.push(`/EQS5/${quote.customerId}/edit`)}>
                          Edit
                        </Dropdown.Item>
                      </DropdownButton>
                    </td>
                    <td>
                      <DropdownButton
                        id="actions"
                        className="quote-dropdown"
                        title={<div className="quote-dropdown-label">{vehicle}</div>}
                        variant="link"
                        alignRight
                        size="xs"
                      >
                        <Dropdown.Item onClick={() => browserHistory.push(`/AVI2/${quote.vehicleId}/edit`)}>
                          Edit
                        </Dropdown.Item>
                      </DropdownButton>
                    </td>
                    <td>
                      {users ? (
                        <div className="assigned-to">
                          <OnlineStatus
                            status={(_.find(users, ['id', quote.assignedTo]) || {}).status}
                            className="d-inline-block mr-1"
                          />
                          {`${quote.AssignedTo.firstName} ${quote.AssignedTo.lastName}`}
                        </div>
                      ) : (
                        <>{`${quote.AssignedTo.firstName} ${quote.AssignedTo.lastName}`}</>
                      )}
                    </td>
                    <td>
                      <div className="actions text-right">
                        <DropdownButton id="actions" title="Actions" variant="primary" alignRight>
                          {quote.QuoteState.logicalName === 'AWAITING' && (
                            <>
                              <Dropdown.Item onClick={() => handleApprove(quote.id)}>Approve</Dropdown.Item>
                              <Dropdown.Divider />
                            </>
                          )}
                          <Dropdown.Item onClick={() => handleHistory(quote.id)}>History</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleDocuments(quote.id)}>Documents</Dropdown.Item>
                          <Dropdown.Item onClick={() => handleReassign(quote.id, quote.assignedTo)}>
                            Reassign
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item onClick={() => handleCancel(quote.id)}>Cancel</Dropdown.Item>
                        </DropdownButton>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </FlexPanel>
  );
};

ManagerQuoteList.propTypes = {
  toolbar: PropTypes.any,
};

export default ManagerQuoteList;
